import React from 'react';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import { BreadcrumbsV2 } from '@zola/zola-ui/src/components/BreadcrumbsV2';
import { getUserContext } from 'selectors/user/userSelectors';

const BreadcrumbsContainer = styled.div`
  padding: 20px;
`;

export const DayOfBreadcrumbs: React.FC = () => {
  const userContext = useSelector(getUserContext);

  const landingPageUrl = userContext.is_guest
    ? '/wedding-planning/paper'
    : '/wedding-planning/universal';

  const BREADCRUMB_ITEMS = [
    { to: '/', label: 'Home' },
    { to: landingPageUrl, label: 'Invites and paper' },
  ];

  return (
    <BreadcrumbsContainer>
      <BreadcrumbsV2 linkItems={BREADCRUMB_ITEMS} currentSelectionLabel="Day-of paper" />
    </BreadcrumbsContainer>
  );
};
